import React, { useContext } from 'react';
import { TranslationContext } from '../translation/translationContext';

const useTranslate = () => {
  const context = useContext(TranslationContext);

  return (key: string) => {
    const translation = context?.find((translation: any) => translation.key === key)?.value;
    const fallback = `🚩need key or value: ${key}🚩`;
    return translation || fallback;
  };
};

export default useTranslate;
